import { FormControlLabel, Grid, Typography } from "@mui/material";
import React from "react";
import Button from "@mui/material/Button";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { TextField, Checkbox } from "formik-mui";
import { createEnrollment } from "../UserActions";
import { global, profilePage } from "../../../context/global";
import { Capitalize } from "../../../functions/Formatters";

export default function EnrollRequestComponent({ setShowForm }) {
    const dispatch = useDispatch();
    return (
        <Formik
            initialValues={{
                first_name: "",
                last_name: "",
                email: "",
                organisation: "",
                role: "",
                projects: "",
                mailing_duda: false,
                mailing_roadmap: false,
            }}
            validationSchema={Yup.object({
                first_name: Yup.string().required("Voornaam mag niet leeg zijn"),
                last_name: Yup.string().required("Achternaam mag niet leeg zijn"),
                email: Yup.string().email("Ongeldig e-mailadres").required("E-mail mag niet leeg zijn"),
                organisation: Yup.string(),
                role: Yup.string(),
                projects: Yup.string(),
                mailing_duda: Yup.boolean(),
                mailing_roadmap: Yup.boolean(),
            })}
            onSubmit={(values) => {
                createEnrollment(values, dispatch);
                setShowForm(false);
            }}
        >
            {({ isValid }) => (
                <>
                    <Form>
                        <Typography>
                            Uw registratie moet eerst worden gecontroleerd voordat deze operationeel is en aan een omgeving is toegekend. U ontvangt een e-mail wanneer uw registratie is geaccepteerd.
                        </Typography>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12}>

                                <Typography variant="h6">Contactgegevens</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Field component={TextField} fullWidth name="first_name" label="Voornaam" autoFocus />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Field component={TextField} fullWidth name="last_name" label="Achternaam" />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Field component={TextField} fullWidth name="email" label="Email" type="email" />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <Typography variant="h6">{Capitalize(global.employer)}</Typography>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Field component={TextField} fullWidth name="employer" label={Capitalize(global.employer)} />
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <Field component={TextField} fullWidth name="role" label={Capitalize(global.role)} />
                            </Grid>
                            <Grid item xs={12} sm={12}>
                                <Field component={TextField} fullWidth multiline minRows={2} placeholder={"-project\n-project"} name="projects" label="Projecten" />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <Typography variant="h6">Mailinglijsten</Typography>
                                <FormControlLabel
                                    control={<Field component={Checkbox} name="mailing_duda" type="checkbox" />}
                                    label={profilePage.dudaMailing}
                                />
                                <FormControlLabel
                                    control={<Field component={Checkbox} name="mailing_roadmap" type="checkbox" />}
                                    label={profilePage.roadmapMailing}
                                />
                            </Grid>

                            <Grid item xs={12} sm={12}>
                                <Button type="submit" variant="contained" color="primary" disabled={!isValid}>
                                    Verstuur
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                </>
            )}
        </Formik>
    );
}
